import React from 'react'

const Favourites = () => {
  return (
    <div>Favourites</div>
  )
}

export default Favourites